// import { getDataWithParams } from "../helpers/apiHelper";
import { getDataWithParams } from "app/helpers/apiHelperV3";
import { urls } from "./urls";

const API_SPORTS = urls.data.API_SPORTS();
export const fetchSports = (): any => {
  const url = API_SPORTS;
  return getDataWithParams(url, {
    status: "active",
  });
};
